import React from 'react';
export function Footer() {
  return <footer className="bg-[#050505] py-4 px-5 text-center border-t border-[#C0392B]/20" data-id="element-44">
      <p className="text-[#444] text-[10px]" data-id="element-45">
        🍕 El Código de la Pizza Pro · Todos los derechos reservados ·{' '}
        <a href="#" className="text-[#666] hover:text-[#C0392B]" data-id="element-46">
          Privacidad
        </a>{' '}
        ·{' '}
        <a href="#" className="text-[#666] hover:text-[#C0392B]" data-id="element-47">
          Términos
        </a>{' '}
        ·{' '}
        <a href="#" className="text-[#666] hover:text-[#C0392B]" data-id="element-48">
          Contacto
        </a>
      </p>
      <p className="text-[#333] text-[9px] mt-1" data-id="element-49">
        Producto digital. Los resultados pueden variar según la práctica del
        usuario.
      </p>
    </footer>;
}